
import 'ol/ol.css';
import OSM from 'ol/source/OSM';
import TileLayer from 'ol/layer/Tile';
import {Map, View} from 'ol';
import TileWMS from 'ol/source/TileWMS';
import {fromLonLat} from 'ol/proj';


const layers5 = 
  new TileLayer({
    
    source: new TileWMS({
      url: urlBaseSIX+'Meteogalicia_Observacion/Extranet_Meteoescolas/MapServer/WmsServer',
      params: {'LAYERS': 'MeteoescolasRede', 'STYLES':'default', 'CRS':'EPSG:4326'},
      
    }),
    
  });



const map = new Map({
  
  layers: [
    new TileLayer({
      source: new OSM(),
    }),  layers5,
  ],
  target: document.getElementById('map-container'),
  view: new View({
    center: fromLonLat([-8.1, 42.8]),
    zoom: 8,
  }),
});



